import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
  routes: [
    {
		path:'/home',
		name: 'Home',
		meta:{title:'首页'},
		component: resolve => require(['@/components/Home'],resolve)
	},
	{
		path:'/',
		name: 'Login',
		meta:{title:'登陆'},
		component: resolve => require(['@/components/Login'],resolve)
	},
	{
		path:'/pwdModity',
		name: 'PasswdModity',
		meta:{title:'修改密码'},
		component: resolve => require(['@/components/PasswdModity'],resolve)
	},
	/*积分管理*/
	{
		path:'/integralManage',
		name: 'IntegralManage',
		meta:{title:'积分管理'},
		component: resolve => require(['@/components/integralManage/IntegralManage'],resolve)
	},
	{
		path:'/integralDetails',
		name: 'IntegralDetails',
		meta:{title:'积分明细'},
		component: resolve => require(['@/components/integralManage/IntegralDetails'],resolve)
	},
	{
		path:'/integralAdd',
		name: 'IntegralAdd',
		meta:{title:'新增积分'},
		component: resolve => require(['@/components/integralManage/IntegralAdd'],resolve)
	},
	{
		path:'/integralAdjustment',
		name: 'IntegralAdjustment',
		meta:{title:'积分调整'},
		component: resolve => require(['@/components/integralManage/IntegralAdjustment'],resolve)
	},
	{
		path:'/integralAudit',
		name: 'IntegralAudit',
		meta:{title:'积分审核'},
		component: resolve => require(['@/components/integralManage/IntegralAudit'],resolve)
	},
	/*余额管理*/
	{
		path:'/balanceManage',
		name: 'BalanceManage',
		meta:{title:'余额管理'},
		component: resolve => require(['@/components/balanceManage/BalanceManage'],resolve)
	},
	{
		path:'/balanceDetails',
		name: 'BalanceDetails',
		meta:{title:'余额明细'},
		component: resolve => require(['@/components/balanceManage/BalanceDetails'],resolve)
	},
	{
		path:'/balanceAdjustment',
		name: 'BalanceAdjustment',
		meta:{title:'余额调整'},
		component: resolve => require(['@/components/balanceManage/BalanceAdjustment'],resolve)
	},
	{
		path:'/balanceAdd',
		name: 'BalanceAdd',
		meta:{title:'新增余额'},
		component: resolve => require(['@/components/balanceManage/BalanceAdd'],resolve)
	},
	{
		path:'/balanceAudit',
		name: 'BalanceAudit',
		meta:{title:'财务余额审核'},
		component: resolve => require(['@/components/financialManage/BalanceAudit'],resolve)
	},
	{
		path:'/withdrawManage',
		name: 'WithdrawManage',
		meta:{title:'提现管理'},
		component: resolve => require(['@/components/financialManage/WithdrawManage'],resolve)
	},
	{
		path:'/withdrawList',
		name: 'WithdrawList',
		meta:{title:'提现单管理'},
		component: resolve => require(['@/components/financialManage/WithdrawList'],resolve)
	},
	{
		path:'/withdrawDetail',
		name: 'WithdrawDetail',
		meta:{title:'提现单详情'},
		component: resolve => require(['@/components/financialManage/WithdrawDetail'],resolve)
	},
	/*产品管理*/
	{
		path:'/productCategoryList',
		name: 'productCategoryList',
		meta:{title:'产品类别列表'},
		component: resolve => require(['@/components/productManagement/productCategoryManage/productCategoryList'],resolve)
	},
	{
		path:'/addProductCategory',
		name: 'AddProductCategory',
		meta:{title:'新增产品类别'},
		component: resolve => require(['@/components/productManagement/productCategoryManage/AddProductCategory'],resolve)
	},
	{
		path:'/editProductCategory',
		name: 'EditProductCategory',
		meta:{title:'修改产品类别'},
		component: resolve => require(['@/components/productManagement/productCategoryManage/EditProductCategory'],resolve)
	},
	{
		path:'/productManagePageList',
		name: 'productManagePage',
		meta:{title:'产品管理列表'},
		component: resolve => require(['@/components/productManagement/productManage/productManagePageList'],resolve)
	},
	{
		path:'/addProduct',
		name: 'AddProduct',
		meta:{title:'新增产品'},
		component: resolve => require(['@/components/productManagement/productManage/AddProduct'],resolve)
	},
	{
		path:'/editeProduct',
		name: 'EditeProduct',
		meta:{title:'修改产品'},
		component: resolve => require(['@/components/productManagement/productManage/EditeProduct'],resolve)
	},
//	{
//		path:'/addSpecProduct',
//		name: 'AddSpecProduct',
//		meta:{title:'新增产品规格'},
//		component: resolve => require(['@/components/productManagement/productManage/AddSpecProduct'],resolve)
//	},
//	{
//		path:'/stockVindicate',
//		name: 'StockVindicate',
//		meta:{title:'库存维护'},
//		component: resolve => require(['@/components/productManagement/productManage/StockVindicate'],resolve)
//	},
	{
		path:'/productDetails',
		name: 'productDetails',
		meta:{title:'产品详情'},
		component: resolve => require(['@/components/productManagement/productManage/productDetails'],resolve)
	},
	/*订单管理*/
	{
		path:'/orderManage',
		name: 'OrderManage',
		meta:{title:'订单管理'},
		component: resolve => require(['@/components/orderManage/OrderManage'],resolve)
	},
	{
		path:'/refundAdd',
		name: 'RefundAdd',
		meta:{title:'发起退款'},
		component: resolve => require(['@/components/orderManage/RefundAdd'],resolve)
	},
	{
		path:'/refundList',
		name: 'RefundList',
		meta:{title:'退款列表'},
		component: resolve => require(['@/components/orderManage/RefundList'],resolve)
	},
	{
		path:'/orderDetails',
		name: 'OrderDetails',
		meta:{title:'订单详情'},
		component: resolve => require(['@/components/orderManage/OrderDetails'],resolve)
	},
	{
		path:'/cargoReceive',
		name: 'CargoReceive',
		meta:{title:'货品领取'},
		component: resolve => require(['@/components/orderManage/CargoReceive'],resolve)
	},
	/*统计中心*/
	{
		path:'/statisticalStatistics',
		name: 'SalesStatistics',
		meta:{title:'产品销售统计'},
		component: resolve => require(['@/components/statisticalCenter/SalesStatistics'],resolve)
	},
	{
		path:'/grossProfit',
		name: 'GrossProfit',
		meta:{title:'利润统计'},
		component: resolve => require(['@/components/statisticalCenter/GrossProfit'],resolve)
	},
	{
		path:'/stockStatistics',
		name: 'StockStatistics',
		meta:{title:'产品库存统计'},
		component: resolve => require(['@/components/statisticalCenter/StockStatistics'],resolve)
	},
	{
		path:'/guestPointsStatistics',
		name: 'GuestPointsStatistics',
		meta:{title:'客人积分统计'},
		component: resolve => require(['@/components/statisticalCenter/GuestPointsStatistics'],resolve)
	},
	{
		path:'/salesPerformanceStatistics',
		name: 'SalesPerformanceStatistics',
		meta:{title:'销售业绩统计'},
		component: resolve => require(['@/components/statisticalCenter/SalesPerformanceStatistics'],resolve)
	},
	{
		path:'/salesPerformanceStatisticsDetails',
		name: 'SalesPerformanceStatisticsDetails',
		meta:{title:'销售业绩统计详情'},
		component: resolve => require(['@/components/statisticalCenter/SalesPerformanceStatisticsDetails'],resolve)
	},
	{
		path:'/fissionStatistics',
		name: 'FissionStatistics',
		meta:{title:'裂变拉新统计'},
		component: resolve => require(['@/components/statisticalCenter/FissionStatistics'],resolve)
	},
	{
		path:'/newUserCount',
		name: 'NewUserCount',
		meta:{title:'拉新人数统计'},
		component: resolve => require(['@/components/statisticalCenter/NewUserCount'],resolve)
	},
	{
		path:'/orderUserCount',
		name: 'OrderUserCount',
		meta:{title:'促成单人数统计'},
		component: resolve => require(['@/components/statisticalCenter/OrderUserCount'],resolve)
	},
	/*系统管理*/
	{
		path:'/personnelManage',
		name: 'PersonnelManage',
		meta:{title:'人员管理'},
		component: resolve => require(['@/components/systemManage/PersonnelManage'],resolve)
	},
	{
		path:'/personAdd',
		name: 'PersonAdd',
		meta:{title:'人员新增'},
		component: resolve => require(['@/components/systemManage/PersonAdd'],resolve)
	},
	{
		path:'/personModity',
		name: 'PersonModity',
		meta:{title:'人员修改'},
		component: resolve => require(['@/components/systemManage/PersonModity'],resolve)
	},
	{
		path:'/personAuthority',
		name: 'AuthorityManage',
		meta:{title:'人员权限'},
		component: resolve => require(['@/components/systemManage/AuthorityManage'],resolve)
	},
	{
		path:'/functionManage',
		name: 'FunctionManage',
		meta:{title:'功能管理'},
		component: resolve => require(['@/components/systemManage/FunctionManage'],resolve)
	},
	{
		path:'/functionAdd',
		name: 'FunctionAdd',
		meta:{title:'功能新增'},
		component: resolve => require(['@/components/systemManage/FunctionAdd'],resolve)
	},
	{
		path:'/functionModity',
		name: 'FunctionModity',
		meta:{title:'功能修改'},
		component: resolve => require(['@/components/systemManage/FunctionModity'],resolve)
	},
	{
		path:'/eventManage',
		name: 'EventManage',
		meta:{title:'活动管理'},
		component: resolve => require(['@/components/systemManage/EventManage'],resolve)
	},
	{
		path:'/eventAdd',
		name: 'EventAdd',
		meta:{title:'活动新增'},
		component: resolve => require(['@/components/systemManage/EventAdd'],resolve)
	},
	{
		path:'/eventEdit',
		name: 'EventEdit',
		meta:{title:'活动修改'},
		component: resolve => require(['@/components/systemManage/EventEdit'],resolve)
	},
	{
		path:'/codeManage',
		name: 'CodeManage',
		meta:{title:'权益码管理'},
		component: resolve => require(['@/components/systemManage/CodeManage'],resolve)
	},
	{
		path:'/codeAdd',
		name: 'CodeAdd',
		meta:{title:'新增权益码'},
		component: resolve => require(['@/components/systemManage/CodeAdd'],resolve)
	},
	{
		path:'/codeEdit',
		name: 'CodeEdit',
		meta:{title:'编辑权益码'},
		component: resolve => require(['@/components/systemManage/CodeEdit'],resolve)
	},
	{
		path:'/tagManage',
		name: 'TagManage',
		meta:{title:'线路标签管理'},
		component: resolve => require(['@/components/systemManage/tagManage'],resolve)
	},
	{
		path:'/tagAdd',
		name: 'TagAdd',
		meta:{title:'新增标签'},
		component: resolve => require(['@/components/systemManage/tagAdd'],resolve)
	},
	{
		path:'/tagEdit',
		name: 'TagEdit',
		meta:{title:'编辑标签'},
		component: resolve => require(['@/components/systemManage/tagEdit'],resolve)
	},
	{
		path:'/supplierAdd',
		name: 'SupplierAdd',
		meta:{title:'新增供应商'},
		component: resolve => require(['@/components/systemManage/SupplierAdd'],resolve)
	},
	{
		path:'/supplierEdit',
		name: 'SupplierEdit',
		meta:{title:'编辑供应商'},
		component: resolve => require(['@/components/systemManage/SupplierEdit'],resolve)
	},
	{
		path:'/supplierManage',
		name: 'SupplierManage',
		meta:{title:'供应商管理'},
		component: resolve => require(['@/components/systemManage/SupplierManage'],resolve)
	},
	{
		path:'/saleManage',
		name: 'SaleManage',
		meta:{title:'销售维护'},
		component: resolve => require(['@/components/systemManage/SaleManage'],resolve)
	},
	{
		path:'/saleAdd',
		name: 'SaleAdd',
		meta:{title:'销售新增'},
		component: resolve => require(['@/components/systemManage/SaleAdd'],resolve)
	},
	{
		path:'/saleModity',
		name: 'SaleModity',
		meta:{title:'修改销售'},
		component: resolve => require(['@/components/systemManage/SaleModity'],resolve)
	},
	{
		path:'/adsRecom',
		name: 'AdsRecomManage',
		meta:{title:'广告推荐'},
		component: resolve => require(['@/components/systemManage/AdsRecomManage'],resolve)
	},
	{
		path:'/adsAdd',
		name: 'AdsAdd',
		meta:{title:'新增广告'},
		component: resolve => require(['@/components/systemManage/AdsAdd'],resolve)
	},
	{
		path:'/adsModity',
		name: 'AdsModity',
		meta:{title:'修改广告'},
		component: resolve => require(['@/components/systemManage/AdsModity'],resolve)
	},
	// 财务管理
	{
		path:'/financialOrderManage',
		name: 'FinancialOrderManage',
		meta:{title:'财务订单统计'},
		component: resolve => require(['@/components/financialManage/FinancialOrderManage'],resolve)
	},
	{
		path:'/auditWithdraw',
		name: 'AuditWithdraw',
		meta:{title:'奖励提现'},
		component: resolve => require(['@/components/financialManage/AuditWithdraw'],resolve)
	},
	{
		path:'/itineraryManage',
		name: 'ItineraryManage',
		meta:{title:'线路管理'},
		component: resolve => require(['@/components/tourManage/itineraryManage'],resolve)
	},
	{
		path:'/itineraryAdd',
		name: 'ItineraryAdd',
		meta:{title:'新增线路'},
		component: resolve => require(['@/components/tourManage/itineraryAdd'],resolve)
	},
	{
		path:'/itineraryDetail',
		name: 'ItineraryDetail',
		meta:{title:'线路详情'},
		component: resolve => require(['@/components/tourManage/itineraryDetail'],resolve)
	},
	{
		path:'/itineraryEdit',
		name: 'ItineraryEdit',
		meta:{title:'编辑线路'},
		component: resolve => require(['@/components/tourManage/itineraryEdit'],resolve)
	},
	{
		path:'/groupManage',
		name: 'GroupManage',
		meta:{title:'团期管理'},
		component: resolve => require(['@/components/tourManage/groupManage'],resolve)
	},
	{
		path:'/groupAdd',
		name: 'GroupAdd',
		meta:{title:'新增团期'},
		component: resolve => require(['@/components/tourManage/groupAdd'],resolve)
	},
	{
		path:'/groupEdit',
		name: 'GroupEdit',
		meta:{title:'修改单个团期'},
		component: resolve => require(['@/components/tourManage/groupEdit'],resolve)
	},
	{
		path:'/groupPrice',
		name: 'GroupPrice',
		meta:{title:'批量改价'},
		component: resolve => require(['@/components/tourManage/groupPrice'],resolve)
	},
	{
		path:'/groupLeft',
		name: 'GroupLeft',
		meta:{title:'查看余位'},
		component: resolve => require(['@/components/tourManage/groupLeft'],resolve)
	},
	{
		path:'/groupNotice',
		name: 'GroupNotice',
		meta:{title:'出团通知'},
		component: resolve => require(['@/components/tourManage/groupNotice'],resolve)
	},
	{
		path:'/groupDetail',
		name: 'GroupDetail',
		meta:{title:'团期详情'},
		component: resolve => require(['@/components/tourManage/groupDetail'],resolve)
	},
	{
		path:'/tourOrderManage',
		name: 'TourOrderManage',
		meta:{title:'销售订单管理'},
		component: resolve => require(['@/components/tourManage/TourOrderManage'],resolve)
	},
	{
		path:'/operateOrderManage',
		name: 'OperateOrderManage',
		meta:{title:'退款定损'},
		component: resolve => require(['@/components/tourManage/OperateOrderManage'],resolve)
	},
	{
		path:'/financialTourOrderManage',
		name: 'FinancialTourOrderManage',
		meta:{title:'财务订单统计'},
		component: resolve => require(['@/components/tourManage/FinancialTourOrderManage'],resolve)
	},
	{
		path:'/cashierOrderManage',
		name: 'CashierOrderManage',
		meta:{title:'出纳订单统计'},
		component: resolve => require(['@/components/tourManage/CashierOrderManage'],resolve)
	},
	{
		path:'/financialRefundAudit',
		name: 'FinancialRefundAudit',
		meta:{title:'财务退款审核'},
		component: resolve => require(['@/components/tourManage/FinancialRefundAudit'],resolve)
	},
	{
		path:'/cashierRefundAudit',
		name: 'CashierRefundAudit',
		meta:{title:'出纳退款审核'},
		component: resolve => require(['@/components/tourManage/CashierRefundAudit'],resolve)
	},
	{
		path:'/financialRecognition',
		name: 'FinancialRecognition',
		meta:{title:'财务认款'},
		component: resolve => require(['@/components/tourManage/FinancialRecognition'],resolve)
	},
	{
		path:'/financialRecognitionAdd',
		name: 'FinancialRecognitionAdd',
		meta:{title:'确认到账'},
		component: resolve => require(['@/components/tourManage/FinancialRecognitionAdd'],resolve)
	},
	{
		path:'/financialRecept',
		name: 'FinancialRecept',
		meta:{title:'财务收款'},
		component: resolve => require(['@/components/tourManage/FinancialRecept'],resolve)
	},
	{
		path:'/financialReceptAdd',
		name: 'FinancialReceptAdd',
		meta:{title:'新增收款'},
		component: resolve => require(['@/components/tourManage/FinancialReceptAdd'],resolve)
	},
	{
		path:'/operateConfirmLoss',
		name: 'OperateConfirmLoss',
		meta:{title:'操作定损'},
		component: resolve => require(['@/components/tourManage/OperateConfirmLoss'],resolve)
	},
	{
		path:'/salePriceAdjust',
		name: 'SalePriceAdjust',
		meta:{title:'销售调价'},
		component: resolve => require(['@/components/tourManage/SalePriceAdjust'],resolve)
	},
	{
		path:'/saleRefundAudit',
		name: 'SaleRefundAudit',
		meta:{title:'销售退款审核'},
		component: resolve => require(['@/components/tourManage/SaleRefundAudit'],resolve)
	},
	{
		path:'/tourRefundDetail',
		name: 'TourRefundDetail',
		meta:{title:'客人退款详情'},
		component: resolve => require(['@/components/tourManage/TourRefundDetail'],resolve)
	},
	{
		path:'/touristInfo',
		name: 'TouristInfo',
		meta:{title:'客人退款详情'},
		component: resolve => require(['@/components/tourManage/TouristInfo'],resolve)
	},

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js